import {css} from '@emotion/react';
import styled from '@emotion/styled';

import {RatingSnippet} from '@/components/RatingSnippet';

type Props = React.PropsWithChildren<{
  withRating: boolean;
}>;

export const GalleryContainer = styled.div<Props>(
  ({withRating = false}) => css`
    position: relative;

    ${withRating &&
    css`
      &:after {
        content: '';
        position: absolute;
        inset: 0;
        background: linear-gradient(
          to bottom,
          transparent 0%,
          transparent 66.15%,
          rgba(0, 0, 0, 0.8) 100%
        );
        pointer-events: none;
      }
    `}

    /* @TODO add as small size to RatingSnippet */
    ${RatingSnippet} {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 1;
      padding: 8px;
      justify-content: flex-start;
      pointer-events: none;
    }
  `
);
